export const DX_META_SCHEMA_URL_V0_0_2 = 'http://duxis.io/schemas/dx/0.0.2/main.json';
export const DX_META_SCHEMA_URL_V0_3 = 'http://duxis.io/schemas/dx/0.3/main.json';
export const DX_META_SCHEMA_URL_V2_0 = 'http://duxis.io/schemas/dx/2.0/schema.json';
